import { getGenericEndpoint } from './get.api';
import type { GetError500Response } from './types';

export const getError500 = async (lang?: string) => {
	return await getGenericEndpoint<GetError500Response>('errors/500', lang);
};
